// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__13SlZ","label":"Section_label__2W81X","contentWrap":"Section_contentWrap__3851e","footer":"Section_footer__74hL7","footerInner":"Section_footerInner__3Ddrt"};